<template lang="pug">
    div.mx-lg-auto(width="100%")
        v-container.mx-auto(v-if="validEventBody")

            template 
                v-alert.mb-2(
                    v-if="hasSummary"
                    border="left"
                    colored-border
                    color="primary"
                    elevation="1"
                    icon="mdi-text-box-outline"
                )
                    .text-subtitle-2.font-weight-bold AI Call Summary
                    .text-body-2.text-wrap {{ eventBody.event_summary.summary }}
                v-divider(inset)
                v-row
                    v-col(cols='12')
                        v-list-item
                            v-list-item-icon 
                                v-icon(color='primary')
                                    | mdi-calendar
                            v-list-item-content 
                                v-list-item-title.text-wrap
                                    | {{ autoAssistData.friendly_created_at }}
                                v-list-item-subtitle.text-wrap
                                    | Created At
                v-divider(inset)
                v-row
                    v-col(cols='6')
                        v-list-item
                            v-list-item-icon 
                                v-icon(color='primary')
                                    | mdi-account-tie-woman
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow 
                                    | {{ autoAssistData.auto_assistant_type | titleize }}
                                v-list-item-subtitle.text-wrap
                                    | AI Assistant Provider

                    v-col(cols='6' align='left')         
                        v-list-item
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow.text-wrap
                                    | {{ eventBody.event_summary.caller_request }} 
                                v-list-item-subtitle.text-wrap
                                    | Caller Request
                        v-list-item
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow.text-wrap
                                    | {{ eventBody.event_summary.call_outcome }} 
                                v-list-item-subtitle.text-wrap
                                    | Call Outcome
                            
                v-divider(inset)
                v-row
                    v-col(cols='6')
                        v-list-item
                            v-list-item-icon 
                                v-icon(color='primary')
                                    | mdi-account-details-outline
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow 
                                    | {{ eventBody.event_info.caller_first_name }} 
                                v-list-item-subtitle 
                                    | Caller First Name
                    v-col(cols='6')
                        v-list-item
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow 
                                    | {{ eventBody.event_info.caller_last_name }} 
                                v-list-item-subtitle 
                                    | Caller Last Name 

                v-divider(inset)
                v-row
                    v-col(cols='4')
                        v-list-item
                            v-list-item-icon 
                                v-icon(color='primary')
                                    | mdi-car
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow.text-wrap 
                                    div(v-if="eventBody.event_summary.vehicle.year")
                                        | {{ eventBody.event_summary.vehicle.year }}
                                    div(v-else)
                                        | N/a
                                v-list-item-subtitle.text-wrap 
                                    | Vehicle Year
                    v-col(cols='4')
                        v-list-item
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow.text-wrap
                                    div(v-if="eventBody.event_summary.vehicle.make")
                                        | {{ eventBody.event_summary.vehicle.make }}
                                    div(v-else)
                                        | N/a
                                v-list-item-subtitle.text-wrap 
                                    | Vehicle Make
                    v-col(cols='4')
                        v-list-item
                            v-list-item-content 
                                v-list-item-title.list-item-title-overflow.text-wrap
                                    div(v-if="eventBody.event_summary.vehicle.model")
                                        | {{ eventBody.event_summary.vehicle.model }}
                                    div(v-else)
                                        | N/a
                                v-list-item-subtitle.text-wrap 
                                    | Vehicle Model

                v-divider(inset)
                div(v-if="validTranscription")
                    v-list-item
                        v-list-item-icon 
                            v-icon(color="primary")
                                | mdi-account-voice
                        v-list-item-content
                            v-list-item-title.font-weight-bold Call Transcript:
                    v-list-item(v-for="utterance, i in eventBody.transcript" :key="i")
                        v-list-item-icon 
                        v-list-item-content 
                            v-list-item-title.text-wrap.list-item-title-overflow(class="lightgrey")
                                | "{{ utterance.text }}"
                            v-list-item-subtitle(:class="determineSpeakerClass(utterance.line_type)")
                                | Speaker - {{ determineSpeaker(utterance.line_type) }}

                div(v-if="!validEventBody")
                    v-alert(outlined type='info' dense border='left' style="margin-top: 16px;")
                        | There is no call transcription for this call.

        div(v-if="!validEventBody")
            v-alert(outlined type='info' dense border='left' style="margin-top: 16px;")
                | There is no valid data for this call.

</template>

<script lang="ts">
import Vue from 'vue';

import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

Vue.use(Chartkick.use(Chart));

// Components

export default Vue.extend({
    data() {
        return {
            eventBody: {},
        }
    },
    methods: {
        determineSpeaker(lineType) {
            if (lineType === "customer") {
                return "Caller";
            } 

            return "AI";
        },
        determineSpeakerClass(lineType) {
            if (lineType === "customer") {
                return "speaker-caller";
            } 

            return "speaker-ai";
        },
    },
    computed: {
        hasSummary() {
            return !!this.eventBody?.event_summary?.summary?.trim();
        },
        validEventBody() {
            return !!this.eventBody;
        },
        validTranscription() {
            return !!this.eventBody && this.eventBody.transcript?.length > 0;
        }
    },
    components: {
    },
    props: {
        autoAssistData: Object,
        validAutoAssistData: Boolean,
    },
    watch: {
    },
    created() {
        if (this.validAutoAssistData) {
            this.eventBody = JSON.parse(this.autoAssistData.event_body);
        }
    },
    destroyed() {
    },
})
</script>

<style lang="scss" scoped>
#app {
    .speaker-caller {
        color: var(--volie-blue);
    }
    .speaker-ai {
        color: var(--success);
    }
}
</style>